<template>
  <section class="footer-section">
    <footer class="footer desktop-footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-3" data-aos="fade-in" data-aos-duration="1000">
            <div class="footer-main-content">
              <img
                src="/assets/images/logos/white-logo.png"
                class="img-fluid footer-logo"
              />
              <div class="footer-social-icons">
                <a href=""
                  ><img src="/assets/images/icons/whatsapp-14.png" alt=""
                /></a>
                <a href=""
                  ><img src="/assets/images/icons/insta-14.png" alt=""
                /></a>
                <a href=""
                  ><img src="/assets/images/icons/sc-14.png" alt=""
                /></a>
                <a href=""
                  ><img src="/assets/images/icons/fb-14.png" alt=""
                /></a>
              </div>
              <p class="mt-3">
                نهتم في دراية للاستقدام بخدمتكم عن طريق قنوات تواصل متعددة ونضمن
                لكم خدمة متكاملة وتجربة عميل مميزة.
              </p>
            </div>
          </div>
          <div class="col-lg-3" data-aos="fade-in" data-aos-duration="1000">
            <p class="footer-title">خدماتنا</p>
            <ul>
              <li><router-link to="/career">طلب الاستقدام</router-link></li>
              <li><router-link to="/workers">السير الذاتية</router-link></li>
            </ul>
          </div>
          <div class="col-lg-3" data-aos="fade-in" data-aos-duration="1000">
            <p class="footer-title">روابط سريعة</p>
            <ul>
              <li><router-link to="/faq">الأسئله الشائعه</router-link></li>
              <li><router-link to="/contact">تواصل معنا</router-link></li>
            </ul>
          </div>
          <div class="col-lg-3" data-aos="fade-in" data-aos-duration="1000">
            <p class="footer-title">الرقم الموحد</p>
            <a href="tel: 920013370" class="footer-number">920013370</a>
            <button class="main-btn">
              <router-link to="/career">طلب الاستقدام</router-link>
            </button>
          </div>
        </div>
      </div>
      <div class="footer-copyrights mt-5">
        <p>جميع الحقوق محفوظة 2025</p>
      </div>
    </footer>
    <!-- mobile footer -->
    <div
      class="footer pt-4 mobile-footer"
      data-aos="fade-in"
      data-aos-duration="1000"
      data-aos-delay="500"
    >
      <div class="footer-container">
        <div
          class="footer-item"
          data-aos="fade-in"
          data-aos-duration="1000"
          data-aos-delay="500"
        >
          <div class="footer-main-content">
            <img
              src="/assets/images/logos/white-logo.png"
              class="img-fluid footer-logo"
            />
            <p class="footer-title">الرقم الموحد</p>
            <a href="tel: 920013370" class="footer-number">920013370</a>
            <button class="main-btn mt-2">
              <router-link to="/career">طلب الاستقدام</router-link>
            </button>
            <div class="footer-social-icons">
              <a href=""
                ><img src="/assets/images/icons/whatsapp-14.png" alt=""
              /></a>
              <a href=""
                ><img src="/assets/images/icons/insta-14.png" alt=""
              /></a>
              <a href=""><img src="/assets/images/icons/sc-14.png" alt="" /></a>
              <a href=""><img src="/assets/images/icons/fb-14.png" alt="" /></a>
            </div>
          </div>
        </div>
        <div class="footer-item">
          <p class="footer-title">خدماتنا</p>
          <ul>
            <li><router-link to="/career">طلب الاستقدام</router-link></li>
            <li><router-link to="/workers">السير الذاتية</router-link></li>
          </ul>
          <p class="footer-title mt-3">روابط سريعة</p>
          <ul>
            <li><router-link to="/faq">الأسئله الشائعه</router-link></li>
            <li><router-link to="/contact">تواصل معنا</router-link></li>
          </ul>
        </div>
      </div>
      <div class="footer-copyrights mt-5">
        <p>جميع الحقوق محفوظة 2025</p>
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup></script>
